import React from 'react';
import styles from './marketPraposition.module.css';
import Markdown from 'markdown-to-jsx';
import { Button } from '../VideoPlayer/VideoPlayer';

export function MarketProposition({ data }: any) {

  // Helper function to preprocess description and add checkmarks to list items
  const preprocessDescription = (description: string) => {
    return description
      .split('\n')  // Split the description into lines
      .map(line => {
        if (line.trim().startsWith('- ') || line.trim().startsWith('* ')) {
          // If it's a list item, prepend the checkmark
          return `<div class="${styles.listItem}"><span class="${styles.checkmark}">✔</span>${line.substring(2)}</div>`;
        }
        return `<p>${line}</p>`;  
      })
      .join('');  
  };



  if(data?.bannerComponentType === 'AboutSteps'){
  return (  
    <div className={styles.root}>
      <div className={styles.container}>
        {data?.title && (
          <Markdown className={styles.title}>{data?.title}</Markdown>
        )}
        
        {data?.description && (
          <Markdown className={styles.description}>
            {data?.description}
          </Markdown>
        )}

        {data?.cards && (
          <div className={styles.aboutStepsCardContainer}>
            {data?.cards?.map((card: any, index: number) => (
              <div key={index} className={styles.aboutStepsCard}>
                {card?.cardHeader && (
                  <Markdown className={styles.aboutStepsCardHeader}>
                    {card?.cardHeader}
                  </Markdown>
                )}
                {card?.cardTitle && (
                  <Markdown className={styles.aboutStepsCardTitle}>
                    {card?.cardTitle}
                  </Markdown>
                )}

                {card?.cardDescription && (
                  <div
                    className={styles.aboutStepsCardDescription}
                    dangerouslySetInnerHTML={{
                      __html: preprocessDescription(card.cardDescription),
                    }}
                  />
                )}
              </div>
            ))}

            </div>
          )}

        {data?.buttons?.[0]?.label && data?.buttons?.[0]?.action ? (
  <Button
    label={data?.buttons[0]?.label}
    className={styles.buttonStyle}
    onClick={() => data?.buttons[0]?.action()}
  />
          ) : null}
          {data?.hyperLinkText && (
            <Markdown className={styles.hyperLink}>
              {data?.hyperLinkText}
            </Markdown>
          )}
        </div>
      </div >
    );
  }

if(data?.bannerComponentType === 'MarketProposition'){

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        {data?.title && (
          <Markdown className={styles.title}>{data?.title}</Markdown>
        )}
        {data?.description && (
          <Markdown className={styles.description}>
            {data?.description}
          </Markdown>
        )}

        {data?.cards && (
          <div className={styles.cardContainer}>
            {data?.cards?.map((card: any, index: number) => (
              <div key={index} className={styles.card}>
                {card?.cardHeader && (
                  <Markdown className={styles.cardHeader}>
                    {card?.cardHeader}
                  </Markdown>
                )}

                {card?.cardDescription && (
                  <div
                    className={styles.cardDescriptionContainer}
                    dangerouslySetInnerHTML={{
                      __html: preprocessDescription(card.cardDescription),
                    }}
                  />
                )}
              </div>
            ))}

            </div>
          )}

{data?.buttons?.[0]?.label && data?.buttons?.[0]?.action ? (
  <div className={styles.buttonContainer}>
  <Button
    label={data?.buttons[0]?.label}
    className={styles.buttonStyle}
    onClick={() => data?.buttons[0]?.action()}
  /></div>
) : null}
          {data?.hyperLinkText && (
            <Markdown className={styles.hyperLink}>
              {data?.hyperLinkText}
            </Markdown>
          )}
        </div>
      </div >
    );
  }
  return null;
}

